module.exports = function isFunction (fn) {
  return Object.prototype.toString.call(fn) === '[object Function]'
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/x-is-function/index.js
// module id = ./node_modules/x-is-function/index.js
// module chunks = 0